module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "medicine-detail"
  }, [_c('div', [_c('transition', {
    attrs: {
      "name": "notifyFade"
    }
  }, [(_vm.notify !== null) ? _c('div', {
    staticClass: "notify-message-parent"
  }, [_c('div', {
    staticClass: "notify-message"
  }, [_c('div', {
    staticClass: "alert alert-dismissible",
    class: {
      'alert-success': _vm.notify.success, 'alert-danger': _vm.notify.danger, 'alert-warning': _vm.notify.warning
    }
  }, [_c('a', {
    staticClass: "close",
    attrs: {
      "href": "#",
      "data-dismiss": "alert",
      "aria-label": "close",
      "title": "close"
    }
  }, [_vm._v("×")]), _c('p', {
    staticClass: "notify-msg"
  }, [_vm._v(_vm._s(_vm.$t(_vm.notify.message_i18n)))])])])]) : _vm._e()])], 1), _c('ul', {
    staticClass: "breadcrumb"
  }, [(_vm.isSelectMode) ? [_c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.backMedicinesList()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('medicines.select_type')))])])] : [_c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v(_vm._s(_vm.$t('Home')))])], 1), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.backMedicinesList()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('Medicine List')))])])], _c('li', {
    staticClass: "active"
  }, [(_vm.medicine !== null) ? _c('span', [_vm._v(_vm._s(_vm.medicine.attributes['medicine-name']))]) : _vm._e()])], 2), (_vm.loading || !_vm.searchCallbackFlag) ? _c('div', {
    staticClass: "row margin-top"
  }, [_vm._m(0)]) : _vm._e(), (_vm.medicine !== null) ? _c('div', [(_vm.isSelectMode) ? [_c('a', {
    staticClass: "btn btn-default pull-right",
    attrs: {
      "onclick": "window.open('about:blank','_self').close()"
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('Close')))])])] : _vm._e(), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('h2', [_vm._v(_vm._s(_vm.medicine.attributes['medicine-name']))])])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('p', [_vm._v(_vm._s(_vm.medicine.attributes['intro-text'])), (_vm.isSelectMode) ? [_c('a', {
    staticClass: "btn btn-xs btn-info",
    on: {
      "click": function($event) {
        _vm.sendMedicineToReport(_vm.medicine.attributes)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('Explain')))])] : _vm._e()], 2)])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-9"
  }, [_c('h4', {
    staticClass: "text-danger"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle"
  }), _c('span', [_vm._v(_vm._s(_vm.$t('medicines.side_effect')))])]), (_vm.sideEffects) ? _c('p', _vm._l((_vm.sideEffects), function(se) {
    return _c('span', [_vm._v(_vm._s(se.attributes['comment']) + " " + _vm._s(_vm.getAgeText(se))), (_vm.isSelectMode) ? [_c('a', {
      staticClass: "btn btn-xs btn-info",
      on: {
        "click": function($event) {
          _vm.sendDataToReport(se, 'explain')
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('Explain')))]), (se.attributes['category'] === 'serious') ? [_c('a', {
      staticClass: "btn btn-xs btn-success",
      on: {
        "click": function($event) {
          _vm.sendDataToReport(se, 'confirmed')
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('Confirm')))])] : _vm._e()] : _vm._e(), _c('br')], 2)
  })) : _vm._e(), _c('h4', {
    staticClass: "text-info"
  }, [_c('i', {
    staticClass: "fa fa-info-circle"
  }), _c('span', [_vm._v(_vm._s(_vm.$t('medicines.additional_comment')))])]), _vm._l((_vm.splitText(_vm.medicine.attributes['additional-comment'])), function(line) {
    return _c('span', [_vm._v(_vm._s(line)), _c('br')])
  })], 2), _c('div', {
    staticClass: "col-md-3"
  }, [_c('h4', {
    staticClass: "text-muted"
  }, [_c('i', {
    staticClass: "fa fa-tag"
  }), _c('span', [_vm._v(_vm._s(_vm.$t('medicines.yj_code')))])]), _c('strong', [_vm._v(_vm._s(_vm.medicine.attributes['yj-code']))]), _c('h4', {
    staticClass: "text-success"
  }, [_c('i', {
    staticClass: "fa fa-plus-square"
  }), _c('span', [_vm._v(_vm._s(_vm.$t('medicines.medicine_type')))])]), _c('strong', [_vm._v(_vm._s(_vm.medicine.attributes['medicine-type-name']))]), _c('h4', {
    staticClass: "text-success"
  }, [_c('i', {
    staticClass: "fa fa-building"
  }), _c('span', [_vm._v(_vm._s(_vm.$t('medicines.sales_company')))])]), _c('strong', [_vm._v(_vm._s(_vm.medicine.attributes['sales-company-name']))])])])], 2) : _vm._e(), _c('div', {
    staticClass: "row margin-top"
  }, [_c('div', {
    staticClass: "col-xs-4"
  }, [(!_vm.isSelectMode && _vm.isAdminOrPharmacist) ? [_c('a', {
    staticClass: "btn btn-info",
    on: {
      "click": function($event) {
        _vm.goMedicinesEdit(_vm.medicine.attributes['medicine-id'])
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil"
  }), _c('span', [_vm._v(_vm._s(_vm.$t('Edit')))])])] : _vm._e()], 2), _c('div', {
    staticClass: "col-xs-4 col-xs-offset-4 text-right"
  }, [_c('a', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.backMedicinesList()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('Back')))])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 text-center"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/loading.gif")
    }
  }), _c('p', [_vm._v("loading...")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-655b710f!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./src/components/templates/medicine-detail.pug
// module id = 396
// module chunks = 1